module.exports = __webpack_public_path__ + "img/logo-canada-with-flag.19aec9ee.svg";